import { render } from "./updateDetail.vue?vue&type=template&id=2816cc99&scoped=true"
import script from "./updateDetail.vue?vue&type=script&lang=js"
export * from "./updateDetail.vue?vue&type=script&lang=js"

import "./updateDetail.vue?vue&type=style&index=0&id=2816cc99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2816cc99"]])

export default __exports__